/* Built In Imports */

/* External Imports */
import { Box, Skeleton } from '@chakra-ui/react';

/* Internal Imports */
// Components
import FaqContents from '@app-ps/Components/Accordion/FaqContents';
import AwardsAchievements from '@app-ps/Components/Card/AwardsAchievements';
import ScrollGallery from '@app-ps/Components/Slider/ScrollGallery';
import SectionUI from './SectionUI';
import StyleConfig from './StyleConfig';
// import Testimonials from '@app-ps/Components/Slider/Testimonials';
import AboutAwards from '@app-ps/Section/AboutAwards';
import ArtsAsDoorWays from '@app-ps/Section/ArtsAsDoorWays';
import AttendInPerson from '@app-ps/Section/AttendInPerson';
import DiscoverSplendor from '@app-ps/Section/DiscoverSplendor';
import ExploreTags from '@app-ps/Section/ExploreTags';
import FeaturedProductions from '@app-ps/Section/FeaturedProductions';
import GetInvolved from '@app-ps/Section/GetInvolved';
import Interested from '@app-ps/Section/Interested';
import Origin from '@app-ps/Section/Origin';
import OurOfferings from '@app-ps/Section/OurOfferings';
import OurPerformers from '@app-ps/Section/OurPerformers';
import Productions from '@app-ps/Section/Productions';
import ProgramDetails from '@app-ps/Section/ProgramDetails';
import ProgramsList from '@app-ps/Section/ProgramsList';
import PsIntroSection from '@app-ps/Section/PsIntroSection';
import ThreeCardSection from '@app-ps/Section/ThreeCardSection';
import UpcomingList from '@app-ps/Section/UpcomingList';
import Vision from '@app-ps/Section/Vision';
import WhatIsPS from '@app-ps/Section/WhatIsPS';
import Workshops from '@app-ps/Section/Workshops';
import WorkshopsUnique from '@app-ps/Section/WorkshopsUnique';
import { Suspense } from 'react';

/**
 * Renders Render Sections
 *
 * @param {object} sectionContent - Data
 * @param {string} region - Region of Page
 * @param {string} lang - Language of Page
 * @param sectionContent.region
 * @param sectionContent.lang
 * @param sectionContent.pType
 * @param sectionContent.csrData
 * @param sectionContent.pageData
 * @returns {ReactElement} Render Sections
 */
const RenderSections = ({
  section,
  region,
  lang,
  pType,
  csrData,
  pageData,
  headerMenuData,
}) => {
  const { sectionId } = section;
  // console.log(pageData, 'dkdfmdk');

  if (sectionId === 'awards-achievements') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <AwardsAchievements
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'testimonials') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        section={section}
        lang={lang}
        region={region}
      >
        {/* <Testimonials
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        /> */}
      </StyleConfig>
    );
  } else if (sectionId === 'what-is-ps') {
    return section.sectionContent.length ? (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <WhatIsPS
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    ) : null;
  } else if (sectionId === 'origin') {
    return section.sectionContent.length ? (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <Origin
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    ) : null;
  } else if (sectionId === 'vision') {
    return section.sectionContent.length ? (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <Vision
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    ) : null;
  } else if (sectionId === 'about-awards') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <AboutAwards
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'attend_in_person') {
    return section.sectionContent.length ? (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <AttendInPerson
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    ) : null;
  } else if (sectionId === 'Interested') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <Interested
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'doorways') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <ArtsAsDoorWays
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'scroll-gallery') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <ScrollGallery
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'productions') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <Productions
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'ps-intro-section') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <PsIntroSection
          sectionContent={section.sectionContent}
          section={section}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'workshops-unique') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <WorkshopsUnique
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'upcoming-list') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <UpcomingList
          section={section}
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'workshops') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <Workshops
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'our-offerings') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <OurOfferings
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'get-involved') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <GetInvolved
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (sectionId === '3-card-section') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <ThreeCardSection
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'discover-splendor') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <DiscoverSplendor
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'our-performers') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <OurPerformers
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'featured-productions') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <FeaturedProductions
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'programs-list') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <ProgramsList
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'explore-tags') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <ExploreTags
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'program-details') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <ProgramDetails
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'faq-section') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        lang={lang}
        region={region}
      >
        <FaqContents
          region={region}
          lang={lang}
          sectionContent={section.sectionContent}
        />
      </StyleConfig>
    );
  } else {
    return (
      <Box as="div" display="block" placeContent="center" w="100%">
        <Suspense fallback={<Skeleton />}>
          {section?.sectionContent?.length > 0
            ? section?.sectionContent?.map((secCon, i) => {
                return (
                  <StyleConfig
                    id={section?.sectionId}
                    key={section?.sectionId}
                    style={section?.styleConfig}
                    section={section}
                    // pT="0"
                    pB={{ base: '0', md: '15px' }}
                    // mB="0"
                    lang={lang}
                    region={region}
                  >
                    <SectionUI
                      key={i}
                      sectionContent={secCon}
                      section={section}
                      region={region}
                      lang={lang}
                      pType={pType}
                      csrData={csrData}
                      pageData={pageData}
                      headerMenuData={headerMenuData}
                    />
                  </StyleConfig>
                );
              })
            : null}
        </Suspense>
      </Box>
    );
  }
};

export default RenderSections;
